<template>
  <div>
    <el-form
      :model="formData"
      :rules="rules"
      ref="form"
      class="main-form-scroll"
    >
      <el-form-item :label="$t('server.name')" prop="nameSelected">
        <el-input v-model="formData.nameSelected"></el-input>
      </el-form-item>
      <el-form-item :label="$t('server.serverType')" prop="serverTypeSelected">
        <el-select
          v-model="formData.serverTypeSelected"
          filterable
          :placeholder="$t('server.serverTypeNotSelected')"
        >
          <el-option
            v-for="type in getTypeSrv"
            :key="type.typeSrvID"
            :value="type.typeSrvID"
            :label="type.typeSrvName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('server.pathHttp')" prop="urlSelected">
        <el-input v-model="formData.urlSelected"></el-input>
      </el-form-item>
      <el-form-item :label="$t('server.host')" prop="hostSelected">
        <el-input v-model="formData.hostSelected"></el-input>
      </el-form-item>
      <el-form-item :label="$t('server.path')" prop="pathSelected">
        <el-input v-model="formData.pathSelected"></el-input>
      </el-form-item>
      <el-form-item label="tiny" prop="tinySelected">
        <el-input v-model="formData.tinySelected"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="bottom-buttons">
      <div></div>
      <div>
        <el-button class="button-cancel" type="plain" @click="cancelClick">{{
          $t("server.cancel")
        }}</el-button>
        <el-button class="button-confirm" type="success" @click="okClick"
          >OK</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    const validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("server.enterServerName")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    const validateUrl = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("server.enterServerPathUrl")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    const validatePath = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("server.enterServerPath")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    const validateHost = (rule, value, callback) => {
      if (!value) {
        callback(new Error(this.$t("server.enterServerHost")));
      } else if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    const validateTiny = (rule, value, callback) => {
      if (value.trim().includes(" ")) {
        callback(new Error(this.$t("errors.nameHasSpace")));
      } else {
        callback();
      }
    };
    return {
      formData: {
        nameSelected: null,
        serverTypeSelected: null,
        urlSelected: null,
        hostSelected: null,
        pathSelected: null,
        tinySelected: null,
      },
      rules: {
        nameSelected: [
          {
            required: true,
            validator: validateUrl,
            trigger: "blur",
          },
        ],
        serverTypeSelected: [
          {
            required: true,
            message: this.$t("server.enterServerType"),
            trigger: "change",
          },
        ],
        urlSelected: [
          {
            required: true,
            validator: validateUrl,
            trigger: "blur",
          },
        ],
        hostSelected: [
          {
            required: true,
            validator: validateHost,
            trigger: "blur",
          },
        ],
        pathSelected: [
          {
            required: true,
            validator: validatePath,
            trigger: "blur",
          },
        ],
        tinySelected: [
          {
            required: false,
            validator: validateTiny,
          },
        ],
      },
    };
  },
  props: {
    type: String,
  },
  methods: {
    populateForm() {
      this.formData.nameSelected = this.getCurInfo.name;
      this.formData.serverTypeSelected = this.getCurInfo.idTypeSRV;
      this.formData.urlSelected = this.getCurInfo.uRL;
      this.formData.hostSelected = this.getCurInfo.host;
      this.formData.pathSelected = this.getCurInfo.path;
      this.formData.tinySelected = this.getCurInfo.tiny;
    },
    okClick() {
      for (let index in this.formData) {
        if (
          this.formData[index] != null &&
          typeof this.formData[index] === "string"
        ) {
          this.formData[index] = this.formData[index].trim();
        }
      }
      this.$refs["form"].validate((valid, object) => {
        if (valid) {
          this.$emit("data", this.formData);
        } else {
          this.$message.error(this.$t("errors.notAllRequiredFieldsSelected"));
        }
      });
    },
    cancelClick() {
      this.$emit("close");
    },
  },
  computed: {
    ...mapGetters(["getTypeSrv", "getCurInfo"]),
  },
  created() {
    if (this.type === "edit") {
      this.populateForm();
    }
  },
};
</script>

<style scoped>
</style>